import { useState } from "react";
import { Row, Drawer } from "antd";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Container from "../../common/Container";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  CustomNavLinkSmall,
  Outline,
  MobileDrawerHeader,
  MobileDrawerTitle,
  Span,
  LanguagePickerWrapper,
  LanguageIcon,
  LanguageSelect,
  CoursesMobileOnly,
  MobileDrawerMenu,
} from "./styles";
import {
  addLanguageToPath,
  getLanguageFromPath,
  LANGUAGE_LABELS,
  SupportedLanguage,
  SUPPORTED_LANGUAGES,
} from "../../languages";
import PracticeNav from "./PracticeNav";
import ResourcesNav from "./ResourcesNav";
import { getAppStoreUrl } from "../../appStore";

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  const [visible, setVisibility] = useState(false);

  const currentLanguage = getLanguageFromPath(location.pathname);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const switchLanguage = (language: SupportedLanguage) => {
    if (language === currentLanguage) {
      return;
    }

    const nextPath = addLanguageToPath(location.pathname, language);

    history.push({
      pathname: nextPath,
      search: location.search,
      hash: location.hash,
    });

    setVisibility(false);
  };

  const MenuItem = () => {
    return (
      <>
        <PracticeNav onNavigate={() => setVisibility(false)} />
        <CoursesMobileOnly>
          <PracticeNav
            variant="mobile"
            drawerOpen={visible}
            onNavigate={() => setVisibility(false)}
          />
        </CoursesMobileOnly>
        <CustomNavLinkSmall>
          <Link
            to={addLanguageToPath("/organizations", currentLanguage)}
            onClick={() => setVisibility(false)}
          >
            <Span>{t("For Teams")}</Span>
          </Link>
        </CustomNavLinkSmall>
        <ResourcesNav onNavigate={() => setVisibility(false)} />
        <CoursesMobileOnly>
          <ResourcesNav
            variant="mobile"
            drawerOpen={visible}
            onNavigate={() => setVisibility(false)}
          />
        </CoursesMobileOnly>

        <CustomNavLinkSmall style={{ width: "150px" }}>
          <LanguagePickerWrapper>
            <LanguageIcon aria-hidden="true" />
            <LanguageSelect
              aria-label={t("Language")}
              value={currentLanguage}
              onChange={(event) =>
                switchLanguage(event.target.value as SupportedLanguage)
              }
            >
              {SUPPORTED_LANGUAGES.map((language) => (
                <option key={language} value={language}>
                  {LANGUAGE_LABELS[language]}
                </option>
              ))}
            </LanguageSelect>
          </LanguagePickerWrapper>
        </CustomNavLinkSmall>

        <CustomNavLinkSmall style={{ width: "220px" }}>
          <Span>
            <a
              href={getAppStoreUrl(currentLanguage)}
              target="_blank"
              rel="noreferrer"
            >
              <Button>{t("Download Babli")}</Button>
            </a>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer
            to={addLanguageToPath("/", currentLanguage)}
            aria-label="homepage"
          >
            <img
              src="/img/icons/babli_logo_192.png"
              alt="Babli App Logo"
              width="55px"
              height="55px"
            />
          </LogoContainer>

          <NotHidden>
            <MenuItem />
          </NotHidden>

          <Burger
            aria-label={t("Menu")}
            aria-expanded={visible}
            onClick={toggleButton}
          >
            <Outline />
          </Burger>
        </Row>

        <Drawer
          aria-labelledby="mobile-navigation-title"
          closable={false}
          open={visible}
          onClose={toggleButton}
        >
          <MobileDrawerHeader onClick={toggleButton}>
            <MobileDrawerTitle id="mobile-navigation-title">
              {t("Menu")}
            </MobileDrawerTitle>
            <Outline />
          </MobileDrawerHeader>

          <MobileDrawerMenu aria-label={t("Menu")}>
            <MenuItem />
          </MobileDrawerMenu>
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default Header;
